export const de = {
  nav: {
    projects: 'Projekte',
    services: 'Leistungen',
    process: 'Ablauf',
    advantages: 'Vorteile',
    contact: 'Kontakt',
    request: 'Beratung sichern',
  },
  hero: {
    eyebrow: 'Ihr Konzept für Ihre PV-Anlage',
    title: 'Transparent. Einfach. Günstiger.',
    subtitle:
      'PV Yourself ist ein durchdachtes Konzept, mit dem Sie bis zu {{percent}} % sparen können. Sie bestellen Ihre PV-Komponenten direkt beim Großhandel – ohne Aufschläge, die andere Firmen zusätzlich auf die Komponenten draufsetzen.',
    badge: 'Bis zu {{percent}} % sparen',
    badgeNote: 'durch Direktbezug beim Großhandel',
    ctaPrimary: 'Jetzt Beratung sichern',
    ctaSecondary: 'Leistungen ansehen',
  },
  pillars: {
    title: 'Ihr Preisvorteil, nachvollziehbar erklärt',
    direct: { title: 'Direkt bestellen ohne Aufschlag', body: 'Sie bestellen die abgestimmten Komponenten direkt beim Großhandel – ohne zusätzliche Handelsaufschläge.' },
    savings: { title: 'Bis zu {{percent}} % sparen', body: 'Durch den Direktbezug sparen Sie bis zu {{percent}} % gegenüber herkömmlichen Angeboten.' },
    transparent: { title: 'Transparent und fair', body: 'Sie wissen, welche Komponenten Sie bekommen, was sie kosten und wofür Sie bezahlen.' },
  },
  services: {
    eyebrow: 'Unsere Leistungen',
    title: 'Alles aus einer Hand – für Ihre Energiezukunft',
    subtitle: 'Von der Planung bis zur jährlichen Wartung begleiten wir Ihr Projekt vollständig.',
  },
  process: {
    eyebrow: 'In 5 Schritten',
    title: 'Ihr Weg zur eigenen PV-Anlage',
    step: 'Schritt {{number}}',
  },
  trust: {
    eyebrow: 'Erfahrung, die Vertrauen schafft',
    title: 'Warum Plan & Volt',
    items: [
      'Entwickelt aus jahrelanger Erfahrung in der Photovoltaikbranche',
      'Eingetragen bei der Handwerkskammer',
      'Beim Netzbetreiber registriert',
      'Fachgerechte Ausführung durch qualifizierte Elektrofachkräfte',
    ],
    proven: { title: 'Erprobtes Konzept', body: 'Aus jahrelanger Erfahrung entwickelt und in der Praxis tausendfach bewährt.' },
    price: { title: 'Maximaler Preisvorteil', body: 'Sie sparen bis zu {{percent}} % durch Direktbezug beim Großhandel.' },
    transparency: { title: 'Volle Transparenz', body: 'Klare Preise, nachvollziehbare Prozesse und keine versteckten Kosten.' },
    fair: { title: 'Fair & zuverlässig', body: 'Ehrliche Beratung, transparente Abläufe und termingerechte Umsetzung.' },
  },
  contact: {
    eyebrow: 'Kontakt',
    title: 'Jetzt Beratung sichern',
    subtitle: 'Hinterlassen Sie Ihre Daten – wir melden uns zeitnah für einen Vor-Ort-Termin.',
    callUs: 'Rufen Sie uns an',
    whatsappUs: 'Per WhatsApp schreiben',
    whatsappCta: 'Chat öffnen',
    whatsappDraft: 'Hallo, ich interessiere mich für eine PV-Anlage und hätte gerne eine Beratung.',
    writeUs: 'Schreiben Sie uns',
    closing: 'Wir freuen uns auf Ihre Anfrage!',
  },
  form: {
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    street: 'Straße und Hausnummer',
    postalCode: 'PLZ',
    city: 'Ort',
    availability: 'Wann sind Sie erreichbar?',
    availabilityHelper: 'z. B. Mo–Fr ab 17 Uhr oder samstags vormittags',
    preferredAt: 'Wunschtermin (optional)',
    interest: 'Woran sind Sie interessiert?',
    message: 'Ihre Nachricht (optional)',
    consent: 'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung meiner Anfrage zu.',
    submit: 'Anfrage senden',
    submitting: 'Wird gesendet…',
    successTitle: 'Vielen Dank für Ihre Anfrage!',
    successBody: 'Wir haben Ihre Anfrage erhalten und melden uns zeitnah bei Ihnen. Eine Bestätigung ist an Ihre E-Mail-Adresse unterwegs.',
    another: 'Weitere Anfrage senden',
    errorTitle: 'Die Anfrage konnte nicht gesendet werden',
    errorBody: 'Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.',
    required: 'Pflichtfeld',
  },
  validation: {
    name: 'Bitte geben Sie Ihren Namen an (mindestens 2 Zeichen).',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
    phone: 'Bitte geben Sie eine gültige Telefonnummer an.',
    consent: 'Ihre Zustimmung ist erforderlich.',
    tooLong: 'Der Text ist zu lang.',
  },
  interests: {
    PV_ANLAGE: 'PV-Anlage',
    WECHSELRICHTER: 'Wechselrichter',
    SPEICHER: 'Speichersystem',
    WALLBOX: 'Wallbox',
    BALKONKRAFTWERK: 'Balkonkraftwerk',
    WARTUNG: 'Wartung',
    SONSTIGES: 'Sonstiges',
  },
  projects: {
    eyebrow: 'Referenzen',
    title: 'Ausgeführte Projekte',
    subtitle: 'Ein Auszug aus Anlagen, die wir geplant und montiert haben.',
    viewAll: 'Alle Projekte ansehen',
    none: 'Es sind noch keine Projekte veröffentlicht.',
    notFound: 'Dieses Projekt wurde nicht gefunden.',
    backToList: 'Zurück zu den Projekten',
    factLocation: 'Ort',
    factSize: 'Anlagengröße',
    factCompleted: 'Fertigstellung',
    factComponents: 'Komponenten',
    ctaTitle: 'Interesse an einer ähnlichen Anlage?',
  },
  footer: {
    tagline: 'Ihre Anlage. Ihre Entscheidung. Ihr Preisvorteil.',
    legal: 'Rechtliches',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    rights: 'Alle Rechte vorbehalten.',
    adminLogin: 'Admin-Login',
  },
  common: {
    language: 'Sprache',
    toggleTheme: 'Design wechseln',
    back: 'Zurück',
    loading: 'Wird geladen…',
    error: 'Es ist ein Fehler aufgetreten',
    retry: 'Erneut versuchen',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundBody: 'Die aufgerufene Seite existiert nicht.',
    home: 'Zur Startseite',
  },
};
